import { useSelector } from "react-redux";
import type { RootState } from "@/app/store";

// Monitor RTK query fetching state by checking if any queries are in progress
export const useLoading = () =>
  useSelector((state: RootState) => {
    const institutionalState = (state as any).institutional;
    if (!institutionalState?.queries) return false;

    // Check if any query has status 'pending'
    return Object.values(institutionalState.queries).some(
      (query: any) => query?.status === "pending",
    );
  });
